module.exports = __webpack_public_path__ + "static/media/404.d497c96f.png";